/* eslint-disable */
export default {
  download: 'Download',
} as const;

// @key: @#@"download"@#@ @source: @#@"Download"@#@
